"use client"

import Link from "next/link"
import { useState } from "react"
import headerNavLinks from "@/data/headerNavLinks"

const MobileMenu = ({ openClass, handleRemove }) => {
	const closeMenu = () => {
		handleRemove?.()
	}
	// State to track the active status and key
	const [isActive, setIsActive] = useState({
		status: false,
		key: "",
	})

	// Function to handle toggling the active status based on the given key
	const handleToggle = (key) => {
		// Check if the current key matches the active key in the state
		if (isActive.key === key) {
			// If the current key matches, set the active status to false
			setIsActive({
				status: false,
			})
		} else {
			// If the current key does not match, set the active status to true and update the key
			setIsActive({
				status: true,
				key,
			})
		}
	}

	return (
		<>
			<div
				className={`mobile-header-active mobile-header-wrapper-style perfect-scrollbar bg-gray-900 ${openClass}`}
			>
				<div className="mobile-header-wrapper-inner">
					<div className="mobile-header-content-area">
						<div className="perfect-scroll">
							<div className="mobile-menu-wrap mobile-header-border">
								<nav className="mt-15">
									<ul className="mobile-menu font-heading">
										{headerNavLinks.map((link, idx) =>
											link.children && link.children.length ? (
												<li
													className={
														isActive.key === idx
															? "has-children active"
															: "has-children"
													}
													key={idx}
												>
													<span
														className="menu-expand"
														role="button"
														tabIndex={0}
														onClick={() => handleToggle(idx)}
														onKeyDown={(e) => {
															if (e.key === "Enter" || e.key === " ") {
																e.preventDefault()
																handleToggle(idx)
															}
														}}
													>
														<i className="fi-rr-caret-down" />
													</span>
													<Link href={link.href} onClick={closeMenu}>
														{link.title}
													</Link>
													<ul
														className={
															isActive.key === idx
																? "sub-menu d-block"
																: "sub-menu d-none"
														}
													>
														{link.children.map((child, cidx) => (
															<li key={cidx}>
																<Link href={child.href} onClick={closeMenu}>
																	{child.title}
																</Link>
															</li>
														))}
													</ul>
												</li>
											) : (
												<li key={idx}>
													<Link href={link.href} onClick={closeMenu}>
														{link.title}
													</Link>
												</li>
											)
										)}
									</ul>
								</nav>
							</div>
							<div className="site-copyright color-gray-400 mt-30">
								Copyright 2025 © Konrad Broda
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default MobileMenu
